export default __webpack_public_path__ + "static/media/screenshot-2.c712f929.png";